import { Box, styled, Theme, Typography } from '@mui/material';
import { palette } from 'view/themes/palette';

export const CandidateListItem = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '100%',
    height: 'max-content',
    border: `1px solid ${palette.border.default}`,
    borderRadius: '12px',
    padding: '20px',
  };
});

export const CandidateListItemHeading = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '100%',
    minHeight: '72px',
    display: 'flex',
    justifyContent: 'space-between',
  };
});

export const CandidateListItemHeadingInfo = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
  };
});

export const CandidateListItemHeadingInfoTexts = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  };
});

export const CandidateListItemHeadingInfoTitle = styled(Typography)(({
  theme,
}: {
  theme: Theme;
}) => {
  return {
    color: palette.text.header,
    fontWeight: 700,
    fontSize: '18px',
    lineHeight: '130%',

    '> span': {
      color: palette.text.placeholder,
      fontWeight: 500,
    },
  };
});

export const CandidateListItemHeadingInfoSalary = styled(Typography)(({
  theme,
}: {
  theme: Theme;
}) => {
  return {
    color: palette.text.header,
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '128%',
  };
});

export const CandidateListItemHeadingButtons = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    minWidth: 0,
    minHeight: '72px',

    '> div': {
      display: 'flex',
      gap: '4px',
    },

    '> p': {
      color: palette.unknown.icon_grey,
      fontWeight: 400,
      fontSize: '12px',
      lineHeight: '136%',
      textAlign: 'right',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  };
});

export const CandidateListItemMain = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '160px 1fr',
  };
});

export const CandidateListItemMainTitles = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',

    '> p': {
      color: palette.unknown.icon_grey,
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '136%',
    },
  };
});

export const CandidateListItemMainValues = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',

    '> p': {
      color: palette.text.header,
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '136%',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',

      '> span': {
        color: palette.unknown.sub_title_grey,
      },
    },
  };
});

export const Separator = styled(Box)({
  height: '1px',
  backgroundColor: palette.border.default,
  margin: '12px 0',
}) as typeof Box;
